(()=>{
const d=document,h=d.documentElement,$=(s,r=d)=>r.querySelector(s),$$=(s,r=d)=>[...r.querySelectorAll(s)];
const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
const rm=matchMedia('(prefers-reduced-motion:reduce)').matches;
h.classList.add('js');if(window.Shopify&&Shopify.designMode)h.classList.remove('js');

/* header + hero parallax */
const hd=$('[data-hd]'),hm=$('[data-hero-media]');let q=0;
const tick=()=>{q=0;const y=scrollY;if(hd)hd.classList.toggle('is-solid',y>40);if(hm&&!rm&&y<innerHeight)hm.style.transform='translate3d(0,'+y*.12+'px,0) scale(1.06)'};
addEventListener('scroll',()=>{if(!q){q=1;requestAnimationFrame(tick)}},{passive:true});tick();

/* mobile menu */
const bt=$('[data-nav-toggle]');
const nav=v=>{h.classList.toggle('nav-open',v);bt&&bt.setAttribute('aria-expanded',v)};
bt&&bt.addEventListener('click',()=>nav(!h.classList.contains('nav-open')));

/* cart drawer */
const open=v=>{h.classList.toggle('cart-open',v);if(v){const p=$('.cd__panel');p&&p.focus()}};
const render=async()=>{
  const j=await (await fetch(root+'?sections=cart-drawer')).json();
  const n=new DOMParser().parseFromString(j['cart-drawer'],'text/html').querySelector('#shopify-section-cart-drawer');
  const w=$('#shopify-section-cart-drawer');if(n&&w)w.innerHTML=n.innerHTML;
  const c=(await (await fetch(root+'cart.js')).json()).item_count;
  $$('[data-cart-count]').forEach(e=>e.textContent=c);
};
const change=async(line,quantity)=>{
  await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity})});
  await render();
};
d.addEventListener('click',e=>{
  const t=e.target;
  if(t.closest('[data-cart-open]')){e.preventDefault();nav(false);open(true)}
  else if(t.closest('[data-cart-close]'))open(false);
  const l=t.closest('[data-line]');if(l)change(+l.dataset.line,+l.dataset.qty);
});
d.addEventListener('keydown',e=>{if(e.key==='Escape'){open(false);nav(false)}});

/* add to cart */
d.addEventListener('submit',async e=>{
  const f=e.target;if(f.id!=='pf')return;
  e.preventDefault();
  const b=$('[data-atc]',f),lbl=b.textContent;b.classList.add('busy');
  try{
    const r=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(f),headers:{Accept:'application/json'}});
    if(r.ok){b.textContent='ADDED';await render();open(true)}
    else{const j=await r.json();b.textContent=(j.description||'UNAVAILABLE').slice(0,28).toUpperCase()}
  }catch(_){b.textContent='TRY AGAIN'}
  b.classList.remove('busy');setTimeout(()=>{b.textContent=lbl},1800);
});

/* variants */
const vj=$('[data-variants]'),pf=$('#pf');
if(vj&&pf){
  const V=JSON.parse(vj.textContent);
  pf.addEventListener('change',e=>{
    if(!e.target.matches('[data-opt]'))return;
    const sel=$$('[data-opt]:checked',pf).map(i=>i.value);
    $$('[data-oval]',pf).forEach((s,i)=>s.textContent=sel[i]);
    const v=V.find(x=>x.o.every((o,i)=>o===sel[i])),a=$('[data-atc]',pf);
    if(v){
      $('[data-vid]',pf).value=v.id;$('[data-price]').textContent=v.p;
      a.disabled=!v.a;a.textContent=v.a?'ADD TO CART':'SOLD OUT';
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
    }else{a.disabled=true;a.textContent='UNAVAILABLE'}
  });
}

/* reveal */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}}),{rootMargin:'0px 0px -8% 0px'});
  $$('.rv').forEach(e=>io.observe(e));
}else $$('.rv').forEach(e=>e.classList.add('in'));

/* gallery thumbs + zoom */
const zm=$('[data-zm]');
d.addEventListener('click',e=>{
  const t=e.target,g=t.closest('[data-go]');
  if(g){const s=$$('.pdp__s')[+g.dataset.go];s&&s.scrollIntoView({behavior:rm?'auto':'smooth',block:matchMedia('(min-width:900px)').matches?'center':'nearest',inline:'start'})}
  const z=t.closest('[data-zoom]');
  if(z&&zm){zm.querySelector('img').src=z.dataset.zoom;zm.showModal()}
  if(zm&&(t===zm||t.closest('[data-zm-close]')))zm.close();
});

/* recently viewed */
const rvs=$('[data-recent]');
if(rvs){
  const cur=rvs.dataset.handle;let L=[];
  try{L=JSON.parse(localStorage.getItem('loose_rv')||'[]');localStorage.setItem('loose_rv',JSON.stringify([cur,...L.filter(x=>x!==cur)].slice(0,8)))}catch(_){}
  const others=L.filter(x=>x!==cur).slice(0,4);
  if(others.length)Promise.all(others.map(h=>fetch(root+'products/'+h+'?section_id=recent-card').then(r=>r.ok?r.text():''))).then(h=>{
    const g=$('[data-recent-grid]',rvs);g.innerHTML=h.join('');
    $$('.rv',g).forEach(e=>e.classList.add('in'));rvs.hidden=false;
  }).catch(()=>{});
}
})();
